import { createContext, useCallback, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const SettingsContext = createContext(null);

const DEFAULTS = { app_name: "Hi-Work", app_logo: null };

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(DEFAULTS);
  const [loaded, setLoaded] = useState(false);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/settings");
      setSettings({ ...DEFAULTS, ...data });
    } catch {
      /* ignore */
    } finally {
      setLoaded(true);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const update = async (patch) => {
    const { data } = await api.patch("/settings", patch);
    setSettings({ ...DEFAULTS, ...data });
    if (data.app_name) document.title = data.app_name;
    return data;
  };

  useEffect(() => {
    if (settings.app_name) document.title = settings.app_name;
  }, [settings.app_name]);

  return (
    <SettingsContext.Provider value={{ settings, loaded, refresh, update }}>
      {children}
    </SettingsContext.Provider>
  );
}

export function useSettings() {
  return useContext(SettingsContext);
}
